import React from 'react'
import Helmet from 'react-helmet'

import ContactCard from '../components/ContactCard'
import PageLayout from '../components/PageLayout'

const TOIMIHENKILOT = () => (
  <PageLayout pageTitle="TOIMIHENKILÖT">
    <Helmet
      title="TOIMIHENKILÖT"
      // meta={[
      //   { name: 'description', content: 'Sample' },
      //   { name: 'keywords', content: 'sample, something' },
      // ]}
    />
    <h2 style={{ textAlign: 'center' }}>SUKUYHDISTYKSEN HALLITUS 2018-2020</h2>
    <ContactCard
      isBig
      name="KRISTIINA MATTILA-NOUSIAINEN (Ka)"
      title="Puheenjohtaja"
      phone="0400- 458 749"
      email="kristiina.mattilaph@gmail.com"
    />
    <hr />
    <h3>JÄSENET</h3>
    <div className="flexRow">
      <ContactCard
        name="ISMO PELTONEN (Ka)"
        title="Sihteeri, jäsenposti"
        phone="0400-899 743"
        email="ismo.peltonen@dnainternet.net"
      />
      <ContactCard name="PÄIVI JUUTILAINEN (Ka)" />
      <ContactCard name="JOUKO LEINONEN (Ka)" />
      <ContactCard name="MAIRE KALLIOKOSKI (Mi/Ka/Er)" />
      <ContactCard
        name="RAINO MARTTUNEN (Ka)"
        phone="050-541 8140"
        email="raino.marttunen@eduskunta.fi"
      />
      <ContactCard
        name="ARI OJANEN (Er)"
        phone="050-301 7484"
        email="ari.ojanen@elisanet.fi"
      />
      <ContactCard
        name="PIRJO PUNAKALLIO (Ka)"
        phone="040-530 5885"
        email="pirjo.punakallio@welho.com"
      />
      <ContactCard
        name="MIKKO RUOPPI (Mi)"
        phone="040-520 9971"
        email="mikko.ruoppi@phnet.fi"
      />
      <ContactCard name="PETRI SIPILÄ (Ka)" />
      <ContactCard
        name="TARJA WARPENIUS (Ka)"
        phone="040-502 7590"
        email="tarja@warpenius.fi"
      />
    </div>
  </PageLayout>
)

export default TOIMIHENKILOT



// WEBPACK FOOTER //
// ./src/pages/toimihenkilot.js